// extracted by mini-css-extract-plugin
export default {"container":"rs-z","heading":"ss-z","text":"ts-z","info":"us-z","link":"vs-z","fullMaxWidth":"ws-z"};